module.factory('brandService', ['BRANDS', 'DEFAULT_BRAND', function(BRANDS, DEFAULT_BRAND) {

  /**
   * A list of methods available from brandService
   * @type {{getDistributor: (function(*): *), getBrand: (function(*): *), getRedeemCodeFields: (function(): string[])}}
   */
  var service = {
    getBrand: getBrand,
    getDistributor: getDistributor,
    getRedeemCodeFields: getRedeemCodeFields
  };

  return service;

  //////////////////////////////

  /**
   * Get the brand
   * @param param
   * @returns {*}
   */
  function getBrand(param) {
    var brand = BRANDS.brands[param];

    if ( brand === undefined ) {
      brand = BRANDS.brands[DEFAULT_BRAND];
    }

    if (brand.fullGiftProgramName !== '' && brand.commonGiftProgramName !=='') {
      brand.hasGiftProgram = true;
    } else {
      brand.hasGiftProgram = false;
    }

    return brand;
  }

  /**
   * Get the distributor
   * @param param
   * @returns {*}
   */
  function getDistributor(param) {
    return BRANDS.distributors[param.toLowerCase()];
  }

  /**
   * Get the redeem code fields JSON property
   * @returns {string[]}
   */
  function getRedeemCodeFields() {
    return BRANDS.redeemCodeFields.readonly;
  }

}]);
